module.exports = __webpack_public_path__ + "img/1519802507.69176d95.jpg";